import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Params, ActivatedRoute, Router } from '@angular/router';

import { AppConstants } from 'appshared/app-constants';
import * as Models from 'appshared/shared-models';
import { MiscTools } from 'appshared/misc-tools';
import { TextTools } from 'appshared/text-tools';
import { SharedLicenseTools } from 'appshared/shared-license-tools';

import { AuthService } from 'client/app/services/auth.service';
import { UiAlertsService } from 'client/app/components/ui-alerts/ui-alerts.service';
import { MyKeysService } from '../my-keys.service';

import { KeyInfoComponent } from 'client/app/components/shared/key-info/key-info.component';

@Component({
	selector: 'app-license-multi-new',
	templateUrl: './license-multi-new.component.html',
	styleUrls: ['./license-multi-new.component.scss']
})
export class LicenseMultiNewComponent implements OnInit, OnDestroy {
	ac = AppConstants;
	tt = TextTools;
	slt = SharedLicenseTools;
	mt = MiscTools;

	@ViewChild(KeyInfoComponent) keyInfo: KeyInfoComponent = null;

	pageMode: string = 'activation'; // or host or aggregate or ip
	id: number; // user Key ID
	key: string;
	hostid: string;
	authUser: Models.AuthUser;
	// userKey: Models.UserLicenseKey; // for shared code for non-staff mode
	tabID: string = '';

	registeredKey: boolean = false;

	// *********************************************************
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private authService: AuthService,
		private uiAlertsService: UiAlertsService,
		private myKeysService: MyKeysService) {

		this.route.queryParams.subscribe(params => {
			this.tabID = null;
			if (params['tabID']) this.tabID = params['tabID'];
		});

		this.router.routeReuseStrategy.shouldReuseRoute = function () { return false; };

		this.route.paramMap.subscribe(params => {
			this.id = +params.get('id');
			if (isNaN(this.id) || this.id === 0)
				this.key = params.get('id');
			else
				this.registeredKey = true;

			this.hostid = params.get('hostid');
			if (this.hostid && this.hostid !== '')
				this.pageMode = 'hostid';
		});
	}

	// *********************************************************
	ngOnInit(): void {
		// console.log('in ngOnInit pm=' + this.pageMode);
		const sessionUser: Models.AuthUser = this.authService.getUser();
		if (sessionUser != null && sessionUser.id !== 0) {
			this.authUser = sessionUser;
			this.loadData();
		} // if
	}

	// *********************************************************
	ngOnDestroy(): void {
		//
	}

	// *********************************************************
	async loadData() {
		let compCheckCounter: number = 0;
		let compCheckMax: number = 10;
		while (!this.keyInfo && compCheckCounter < compCheckMax) {
			compCheckCounter++;
			// give it a chance to load
			await MiscTools.delay(100);
		} // if

		if (!this.keyInfo) {
			alert('Cannot find keyInfo component - contact support');
			return;
		} // if

		let userKey: Models.UserLicenseKey = null;
		if (!this.registeredKey) {
			// console.log('looks like a pass in by key ' + this.key);
			// call service to check to see if it is a user key
			// if not, return stub with activation...

			userKey = await this.myKeysService.resolveKey(this.key);
			if (userKey) this.id = userKey.id;
			this.registeredKey = userKey.id !== 0;
		} else {
			const retKey = await this.myKeysService.fetchKey(this.id);
			userKey = retKey;
		} // if

		if (!userKey || userKey == null || (this.registeredKey && userKey.id === 0) || !userKey.activation) {
			this.router.navigate([AppConstants.urls.notfound]);
			return;
		}

		this.keyInfo.setupComponent(this.authUser, this.pageMode, userKey.activation, userKey, this.hostid, '', this.tabID, 0);
	}
}
